// The shape of an email address the portal asks for (BRK-S337). PMS validates
// it for real; this only catches an obvious typo before a round trip. One
// copy for the commercial forms (the WC wizard's Business step and its
// contacts); the bond flow keeps its own in brokerGia.ts.
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isEmailShaped(value: string): boolean {
  return EMAIL_SHAPE.test(value.trim());
}
